import { scAuditCard1, scAuditCard2, scAuditCard3 } from '~/assets/images'

export const bigCards = [
  {
    image: scAuditCard1,
    title: 'smart-contract-audits.big-cards.security-report.title',
    description: 'smart-contract-audits.big-cards.security-report.description',
  },
  {
    image: scAuditCard2,
    title: 'smart-contract-audits.big-cards.media-coverage.title',
    description: 'smart-contract-audits.big-cards.media-coverage.description',
  },
  {
    image: scAuditCard3,
    title: 'smart-contract-audits.big-cards.cex.title',
    description: 'smart-contract-audits.big-cards.cex.description',
  },
]
